// extracted by mini-css-extract-plugin
module.exports = {"container":"PhotoUpload_container__2By_M","image":"PhotoUpload_image__1SrDL"};